import React__default, { useRef } from 'react';
import { T as TimeInputFocusController } from './CustomTimeInputFocusController-D2w6Gs_W.js';
import { T as TimeInputState } from './CustomTimeInputState-B68FA0Ot.js';
import { T as TimeInputInputGroup, a as TimeInputSubInput } from './CustomTimeInput.styles-B7pGzlM7.js';
import { n as noop } from '../../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';

const hourOptions = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
const minuteOptions = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'];
const meridiemOptions = ['AM', 'PM'];
const TimeInput = ({
  id,
  value,
  onChange = noop,
  className,
  hourInputLabel,
  minuteInputLabel,
  meridiemInputLabel
}) => {
  const targetInputRef = useRef(null);
  const onChangeTimeInputState = updatedValue => {
    if (typeof window !== 'undefined' && targetInputRef.current) {
      var _Object$getOwnPropert, _targetInputRef$curre;
      const nativeInputValueSetter = Object === null || Object === void 0 || (_Object$getOwnPropert = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')) === null || _Object$getOwnPropert === void 0 ? void 0 : _Object$getOwnPropert.set;
      nativeInputValueSetter === null || nativeInputValueSetter === void 0 || nativeInputValueSetter.call(targetInputRef.current, updatedValue);
      (_targetInputRef$curre = targetInputRef.current) === null || _targetInputRef$curre === void 0 || _targetInputRef$curre.dispatchEvent(new Event('input', {
        bubbles: true
      }));
    }
  };
  return /*#__PURE__*/React__default.createElement(TimeInputFocusController, null, ({
    focus,
    focusNext,
    focusPrevious,
    onFocusHour,
    onFocusMinute,
    onFocusMeridiem,
    onBlur
  }) => /*#__PURE__*/React__default.createElement(TimeInputInputGroup, {
    id: id,
    className: className,
    onClick: () => !focus && onFocusHour()
  }, /*#__PURE__*/React__default.createElement(TimeInputState, {
    value: value,
    onChange: onChangeTimeInputState
  }, ({
    hour,
    onChangeHour,
    minute,
    onChangeMinute,
    meridiem,
    onChangeMeridiem
  }) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TimeInputSubInput, {
    value: hour,
    options: hourOptions,
    isFocus: focus === 'hour',
    onChange: onChangeHour,
    onFocus: onFocusHour,
    onBlur: onBlur,
    focusNext: focusNext,
    focusPrevious: focusPrevious,
    label: hourInputLabel,
    id: `${id}-hour`
  }), ":", /*#__PURE__*/React__default.createElement(TimeInputSubInput, {
    value: minute,
    options: minuteOptions,
    isFocus: focus === 'minute',
    onChange: onChangeMinute,
    onFocus: onFocusMinute,
    onBlur: onBlur,
    focusNext: focusNext,
    focusPrevious: focusPrevious,
    label: minuteInputLabel,
    id: `${id}-minute`
  }), '\u00A0' /* &nbsp <-- prevent jsx parsing problem with html escaping */, /*#__PURE__*/React__default.createElement(TimeInputSubInput, {
    value: meridiem,
    options: meridiemOptions,
    isFocus: focus === 'meridiem',
    onChange: onChangeMeridiem,
    onFocus: onFocusMeridiem,
    onBlur: onBlur,
    focusNext: focusNext,
    focusPrevious: focusPrevious,
    label: meridiemInputLabel,
    id: `${id}-meridiem`
  }), /*#__PURE__*/React__default.createElement("input", {
    ref: targetInputRef,
    style: {
      display: 'none'
    },
    onChange: onChange
  })))));
};

export { TimeInput as T };
//# sourceMappingURL=CustomTimeInput-8ZU0dLDb.js.map
